import angular from 'angular';
import { RogersEmployeeSalesReportComponent } from './employee-sales-report/rogers-employee-sales-report.component';
import { RogersOwnerPayoutReportContainerComponent } from './rogers-owner-payout-report/rogers-owner-payout-report-container.component';
import { RogersIcdPostedPayoutDetailReportComponent } from './rogers-icd-posted-payout-detail-report/rogers-icd-posted-payout-detail-report.component';
import { RogersHybridPayoutReportComponent } from './rogers-payout-report/rogers-hybrid-payout-report-container.component';
import { RogersPayoutReportComponent } from './rogers-payout-report/rogers-payout-report.component';
import { EmployeeInstallStatusComponent } from './employee-install-status/employee-install-status.component';

/**
 * A module containing components that display payout reports containing information
 * specialized for the Rogers division.
 */
export const PayoutReportRogersModule = angular
    .module("apex.mainApp.payout.report.rogers", [])
    .component("apexEmployeeSalesReport", RogersEmployeeSalesReportComponent)
    .component("apexRogersEmployeeInstallStatus", EmployeeInstallStatusComponent)
    .component("apexRogersIcdPostedPayoutDetailReport", RogersIcdPostedPayoutDetailReportComponent)
    .component("apexRogersOwnerPayoutReportContainer", RogersOwnerPayoutReportContainerComponent)
    .component("apexRogersHybridPayoutReport", RogersHybridPayoutReportComponent)
    .component("apexRogersPayoutReport", RogersPayoutReportComponent)
    .name;
